import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useArtcle = (article_id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const artcle = sharedRef(null, `useArtcle-${article_id}`);
  const artcleList = sharedRef(null, `useArtcle-${article_id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useArtcle-loading-${article_id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useArtcle-error-${article_id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const articleGet = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.artcleGet(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        artcleList.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    articleGet: articleGet,
    artcle: computed(() => artcle.value),
    artcleList: computed(() => artcleList.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
